import { API_URL } from '../../../app-config/constants';
import { get } from '../request';

getAll.operation = 'READ';
export function getAll({ cycleId, managerId }) {
    const path = `${API_URL}/review-cycle/` + cycleId + '/reviews-graph';
    return get(path + (managerId ? '?mainReviewerId=' + managerId : ''));
}
